<template>
  <div class="broker-comparison-container">
    <div class="broker-comparison-header">
      <h1 class="comparison-title">BEST Brokerages for United States Clients</h1>
      <p class="comparison-description">
        Our website contains affiliate links to brokers. If you sign up and make a deposit through our link, we may earn a commission at no additional cost to you. This helps support our content and website. However, this has no bearing on our reviews and comparisons. We strive to provide fair and balanced information to help you make the best decision for your needs.
      </p>
    </div>

    <div class="brokers-grid">
      <div v-for="broker in brokers" :key="broker.id" class="broker-wrapper">
        <div v-if="broker.banner" class="banner">
          <div class="banner-content">
            <div class="banner-title">{{ broker.banner.title }}</div>
            <div class="banner-badge">{{ broker.banner.badge }}</div>
          </div>
        </div>
        <div class="broker-card">
            <div class="card-header-section">
            <div class="broker-logo">
                <img :src="broker.logo" :alt="broker.name" />
            </div>
            <div class="broker-rating">
                <i v-for="i in 5" :key="i" class="fas fa-star star"></i>
            </div>
            <button class="signup-btn" @click="openBrokerLink(broker.link)">SIGN UP</button>
            </div>

            <div class="card-content">
            <div class="pros-cons-section">
                <h3 class="section-title">PROS & CONS</h3>
                <ul class="feature-list">
                <li v-for="(pro, index) in broker.pros" :key="`pro-${index}`" class="pro">
                    <i class="fas fa-check-circle asset-checkmark"></i>
                    <span>{{ pro }}</span>
                </li>
                <li v-for="(con, index) in broker.cons" :key="`con-${index}`" class="con">
                    <i class="fas fa-times x-mark"></i>
                    <span>{{ con }}</span>
                </li>
                </ul>
            </div>

            <div class="tradeable-assets-section">
                <h3 class="section-title">TRADEABLE ASSETS</h3>
                <ul class="asset-list">
                <li v-for="(asset, index) in broker.assets" :key="`asset-${index}`" class="asset">
                    <i v-if="asset.isCon == true" class="fas fa-check-circle asset-checkmark"></i>
                    <i v-else class="fas fa-times x-mark"></i>
                    <span>{{ asset.msg }}</span>
                </li>
                </ul>
            </div>
            </div>

            <p class="affiliate-note">
                Affiliate receives a commission for accounts opened through the link on this page <br>
                *Cryptocurrencies are offered through Paxos, Paxos is a separate legal entity from OANDA
            </p>


            <button class="bonus-btn" @click="openBrokerLink(broker.link)">{{ broker.bonus }}</button>

            <p class="terms-note">*Terms & Conditions Apply</p>
        </div>
      </div>

    </div>

    <div class="disclaimer-footer">
      <h5>DISCLAIMER:</h5>
      <p class="disclaimer-text">
        OANDA Corporation is authorized to provide specific financial services and is regulated by the CFTC/NFA. OANDA is a member firm of the NFA (Member ID: 0325821). CFDs like foreign currency contracts for difference are not available to U.S. residents.
      </p>
      <p class="disclaimer-text">
        Trading in virtual currencies is high risk. All virtual currency transactions occur on the Paxos Trust Company exchange. Paxos is not an NFA member and is not subject to the NFA's regulatory oversight and examinations. OANDA Corporation is not party to any transactions in virtual currencies and does not custody virtual currencies on your behalf.
      </p>
      <p class="disclaimer-text">
        Trading on leverage is high risk and is not suitable for all investors. You may lose more than you invest. We advise that you consider very carefully whether leveraged trading, or any form of trading, is right for you. Seek independent financial advice and ensure you fully understand the risks involved before you begin trading.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrokerComparison',
  data() {
    return {
      brokers: [
        {
          id: 1,
          name: 'OANDA',
          logo: require('@/assets/logo_collections/oanda-logo-dark.svg'),
          link: 'https://www.oanda.com',
          bonus: 'Up To $25k* Bonus',
          banner: {
            title: 'OANDA',
            badge: '#1 Forex Broker'
          },
          pros: [
            'Regulated By CFTC/NFA',
            // 'Get FREE Tradingview Premium',
            'Low Trading Fees'
          ],
          cons: [
            'Limited Leverage Options'
          ],
          assets: [
            {isCon: true, msg: 'Forex Pairs'},
            {isCon: true, msg: 'Cryptocurrencies*'},
            {isCon: false, msg: 'Indices, Gold, ETFs'},
            {isCon: false, msg: 'Options'}
          ]
        },
        // {
        //   id: 2,
        //   name: 'Interactive Brokers',
        //   logo: require('@/assets/logo_collections/ic_markets.webp'),
        //   link: 'https://www.interactivebrokers.com',
        //   bonus: 'Up To $1000* Bonus',
        //   pros: [
        //     'Regulated By SEC/FINRA',
        //     'Advanced Trading Tools',
        //     'Very Low Commissions'
        //   ],
        //   cons: [
        //     'Minimum Account Size Required'
        //   ],
        //   assets: [
        //     'Stocks',
        //     'Options',
        //     'Forex Pairs'
        //   ]
        // },
        // {
        //   id: 3,
        //   name: 'Pepperstone',
        //   logo: require('@/assets/logo_collections/pepperstone.webp'),
        //   link: 'https://www.pepperstone.com',
        //   bonus: 'Up To $5000* Bonus',
        //   pros: [
        //     'ASIC Regulated',
        //     'Tight Spreads',
        //     'Multiple Account Types'
        //   ],
        //   cons: [
        //     'Limited to Forex & CFDs'
        //   ],
        //   assets: [
        //     'Forex Pairs',
        //     'CFDs',
        //     'Commodities'
        //   ]
        // }
      ]
    };
  },
  methods: {
    openBrokerLink(link) {
      window.open(link, '_blank');
    }
  }
};
</script>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

::v-deep #app {
  overflow: auto;
  height: 100vh;
}

.broker-comparison-container {
  background: linear-gradient(135deg, #1a1f3a 0%, #2c2d53 100%);
  min-height: 100vh;
  padding: 60px 20px 40px;
}

.broker-comparison-header {
  max-width: 1200px;
  margin: 0 auto 60px;
  text-align: center;
}

.comparison-title {
  font-size: 48px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 30px;
  letter-spacing: 1px;
}

.comparison-description {
  font-size: 16px;
  color: #b8bcc8;
  line-height: 1.6;
  max-width: 900px;
  margin: 0 auto;
}

.brokers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  gap: 30px;
  /* max-width: 1200px; */
  max-width: 800px;
  margin: 0 auto;
}

.broker-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: transform 0.3s ease;
  background-color: white;
  justify-content: center;
  border-radius: 25px;
}

/* .broker-wrapper:hover .broker-card {
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
  transform: translateY(-5px);
} */

/* .broker-wrapper:hover .banner {
  transform: translateX(-5px);
} */

.banner {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
  color: #ffffff;
  padding: 30px 20px;
  /* border-radius: 15px 15px 0 0; */
  margin-left: -200px;
  margin-right: 0;
  /* width: calc(100% + 40px); */
  width: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0 5px 15px rgba(255, 107, 107, 0.2);
  z-index: 1;
}

.banner-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.banner-title {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
}

.banner-badge {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}

.broker-card {
  background: #ffffff;
  border-radius: 0 0 15px 15px;
  overflow: hidden;
  /* box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2); */
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-left: 25px;
}

.card-header-section {
  padding: 30px 20px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.broker-logo {
  width: 150px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.broker-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.broker-rating {
  display: flex;
  gap: 5px;
  justify-content: center;
}

.star {
  font-size: 24px;
  color: #ff6b6b;
}

.signup-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
  color: #ffffff;
  border: none;
  padding: 10px 35px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(255, 107, 107, 0.3);
}

.signup-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 20px rgba(255, 107, 107, 0.4);
}

.card-content {
  padding: 30px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  flex-grow: 1;
  /* border-bottom: 1px solid #f0f0f0; */
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 15px;
  letter-spacing: 0.5px;
}

.feature-list,
.asset-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li,
.asset-list li {
  padding: 8px 0;
  font-size: 14px;
  color: #555;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pro .checkmark,
.asset .asset-checkmark {
  /* color: #26a65b; */
  color: #e74c3c;
  font-weight: bold;
  font-size: 16px;
}
li .asset-checkmark {
  color: #e74c3c;
}

.con .x-mark {
  color: #e74c3c;
  font-weight: bold;
  font-size: 16px;
}

.asset .x-mark {
    color: #e74c3c;
    font-weight: bold;
}

.affiliate-note {
  padding: 0 20px;
  font-size: 12px;
  color: #999;
  margin-bottom: 15px;
  line-height: 1.5em;
}

.bonus-btn {
  margin: 0 20px 20px;
  background: linear-gradient(135deg, #1abc9c 0%, #16a085 100%);
  color: #ffffff;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(26, 188, 156, 0.3);
}

/* .bonus-btn:hover {
  transform: scale(1.02);
  box-shadow: 0 8px 20px rgba(26, 188, 156, 0.4);
} */

.terms-note {
  padding: 0 20px 20px;
  font-size: 12px;
  color: #999;
  margin: 0;
  text-align: center;
}

.disclaimer-footer {
  text-align: center;
  max-width: 1200px;
  margin: 60px auto 0;
  padding: 40px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.disclaimer-text {
  text-align: center;
  font-size: 14px;
  color: #999;
  line-height: 1.6;
  margin-bottom: 15px;
  /* text-align: justify; */
}

.disclaimer-text:last-child {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .broker-comparison-container {
    padding: 40px 15px 30px;
  }

  .comparison-title {
    font-size: 32px;
    margin-bottom: 20px;
  }

  .brokers-grid {
    grid-template-columns: 1fr;
  }

  .card-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .disclaimer-text {
    font-size: 14px;
    text-align: left;
  }
}
</style>
